// @flow

import React from 'react';
import styled from 'styled-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const BoxSearch = styled.div`
  position: relative;
  height: 30px;
  font-size: 14px;
  line-height: 17px;
  ::placeholder {
    font-size: 14px;
    line-height: 17px;
    color: #9b9b9b;
  }
  svg {
    height: 18px;
    width: 18px;
    color: #7c7c7c;
    position: absolute;
    right: 0%;
    top: 50%;
    margin: 0 50px;
    transform: translateY(-50%);
  }
  margin-left: 15px;
`;

const StyledSearch = styled.input`
  padding-right: 30px;
  width: 300px;
  height: 28px;
  background: #ffffff;
  margin-right: 34px;
  border-radius: 5px;
  border: 1px solid #c8c8c8;
  outline: none;
`;

type PropsType = {
  placeholder: string,
  name: string,
  value: string,
  onChangeFilter: (text: string) => void
};

const SearchFilter = ({
  placeholder,
  name,
  value,
  onChangeFilter
}: PropsType) => (
  <BoxSearch>
    <StyledSearch
      type="text"
      placeholder={placeholder}
      name={name}
      defaultValue={value}
      onKeyDown={e => {
        if (e.keyCode == 13) onChangeFilter(e.target.value);
      }}
    />
    <FontAwesomeIcon icon="search" />
  </BoxSearch>
);

export default SearchFilter;
